import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))

const CommentsSidebar = lazy(() => import('./CommentsSidebar'))

class CommentsSidebarWebComponent extends ReactWebComponent {
  override render() {
    return (
      <RootProviders>
        <CommentsSidebar />
      </RootProviders>
    )
  }
}

customElements.define('comments-sidebar', CommentsSidebarWebComponent)
